import { ServerFetch } from '../main-model'

export default class ProductGenerationListModel extends ServerFetch {
    getProductGenerationListBy = (data) => this.authFetch({
        url: 'product-generation-list/getProductGenerationListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}